import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { filter, map, Observable, Subject } from 'rxjs';
import { CreditReport } from '@app/app/interfaces/credit-reports/credit-report.model';
import { FinancesState } from '@app/app/store/finances/finances.state';
import { ListValueDisplayable } from '@app/app/interfaces/list-value-displayable.model';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { BorrowerValue } from '@app/app/interfaces/borrower-value.model';

@Component({
  selector: 'app-credit-report',
  templateUrl: 'credit-report.component.html',
})
export class CreditReportComponent implements OnInit, OnDestroy {

  @Input() contactId!: number;

  contactCreditReport$: Observable<CreditReport>;
  creditReportListValues$: Observable<Partial<BorrowerValue>[]>;
  destroyed$ = new Subject<boolean>();

  displayableValuesMap: {[key: string]: {label: string; value: (val) => any }} = {
    publicRecordsCount: {
      label: '# of public records',
      value: (val) => val,
    },
    installmentBalance: {
      label: 'Installment balance',
      value: (val) => this.currencyPipe.transform(val),
    },
    revolvingBalance: {
      label: 'Revolving balance',
      value: (val) => this.currencyPipe.transform(val),
    },
    realEstateBalance: {
      label: 'Real estate balance',
      value: (val) => this.currencyPipe.transform(val),
    },
    revolvingAvailablePercent: {
      label: 'PCT revolving availability',
      value: (val) => `${val}%`,
    },
    inquiriesDuringLast6Months: {
      label: '6 month inquiries',
      value: (val) => val,
    },
    delinquenciesOver30Days: {
      label: '30 day delinquencies',
      value: (val) => val,
    },
    delinquenciesOver60Days: {
      label: '60 day delinquencies',
      value: (val) => val,
    },
    delinquenciesOver90Days: {
      label: '90 day delinquencies',
      value: (val) => val,
    },
    derogCounter: {
      label: '# of derogatory marks',
      value: (val) => val,
    }
  }

  constructor(
    private store: Store,
    private currencyPipe: CurrencyPipe,
    private percentPipe: PercentPipe,
  ) {}

  ngOnInit():void {
    this.contactCreditReport$ = this.store.select( FinancesState.creditReportByContactId(this.contactId) );
    this.creditReportListValues$ = this.contactCreditReport$.pipe(
      takeUntil(this.destroyed$),
      filter(val => !!val),
      map( contactCreditReport => {
        return Object.keys(contactCreditReport)
          .filter( ccrValueKey => !!this.displayableValuesMap[ccrValueKey] )
          .map( ccrValueKey => {
            const mapConfig = this.displayableValuesMap[ccrValueKey];
            return {
              shortName: mapConfig.label,
              value: mapConfig.value(contactCreditReport[ccrValueKey]),
            };
        })
      })
    );

  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
